module.exports = __webpack_public_path__ + "static/media/matilde-special-indiana-sleepy.f43a3f47.png";